import React, { useEffect } from 'react';
import { getDisplayName } from '../../utils/admin';
import { plainTextOf } from '../../utils/messageActions';
import { useBackClose } from '../../utils/backStack';

export const REACTION_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🎉'];

// 모바일: 메시지를 길게 누르면 아래에서 올라오는 메뉴 (반응 · 반응한 사람 · 답장 · 복사 · 수정 · 저장 · 삭제)
export function MessageSheet({ msg, myUsername, actions, onClose }) {
    useBackClose(true, onClose); // 뒤로가기(안드로이드)로 닫기
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    // 복사 등은 사용자의 탭(제스처) 안에서 실행돼야 하므로 먼저 실행하고 닫는다
    const run = (fn) => () => { fn(); onClose(); };
    const reactions = msg.reactions ? Object.entries(msg.reactions).filter(([, users]) => Array.isArray(users) && users.length) : [];
    const preview = plainTextOf(msg).replace(/\s+/g, ' ').slice(0, 80);

    return (
        <div className="sheet-backdrop" onClick={onClose}>
            <div className="sheet" role="dialog" aria-label="메시지 메뉴" onClick={e => e.stopPropagation()}>
                <div className="sheet-handle" />
                <div className="sheet-preview"><strong>{getDisplayName(msg.username)}</strong> {preview}</div>

                {!msg.is_deleted && actions.react && (
                    <div className="sheet-reactions">
                        {REACTION_EMOJIS.map(emoji => {
                            const mine = Array.isArray(msg.reactions?.[emoji]) && msg.reactions[emoji].includes(myUsername);
                            return <button key={emoji} className={mine ? 'active' : ''} onClick={run(() => actions.react(emoji))}>{emoji}</button>;
                        })}
                    </div>
                )}

                {reactions.length > 0 && (
                    <div className="sheet-reactors">
                        {reactions.map(([emoji, users]) => (
                            <div key={emoji} className="sheet-reactor-row">
                                <span className="sheet-reactor-emoji">{emoji} {users.length}</span>
                                <span className="sheet-reactor-names">{users.map(getDisplayName).join(', ')}</span>
                            </div>
                        ))}
                    </div>
                )}

                <div className="sheet-actions">
                    {actions.edit && <button onClick={run(actions.edit)}><span>✏️</span>수정</button>}
                    {actions.reply && <button onClick={run(actions.reply)}><span>↪️</span>답장</button>}
                    {actions.copyText && <button onClick={run(actions.copyText)}><span>📋</span>텍스트 복사</button>}
                    {actions.toggleSave && <button onClick={run(actions.toggleSave)}><span>🔖</span>{actions.isSaved ? '저장 취소' : '메시지 저장'}</button>}
                    {actions.copyLink && <button onClick={run(actions.copyLink)}><span>🔗</span>링크 복사</button>}
                    {actions.rollback && <button onClick={run(actions.rollback)}><span>🔄</span>복구</button>}
                    {actions.remove && <button className="danger" onClick={run(actions.remove)}><span>🗑️</span>삭제</button>}
                </div>
                <button className="sheet-cancel" onClick={onClose}>닫기</button>
            </div>
        </div>
    );
}
